import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, IconButton } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { ActionButton } from 'core/components/action-button';
import Field from 'core/components/form/form.v2';
import deleteIcon from 'core/assets/svg/delete-icon.svg';
import caret from 'core/assets/svg/caretOrange.svg';
import useStyles from './sub-risk.styles';

const CollapsibleListItem = ({ title, rightSideValues, detailFields, onDelete, disabled, keyPrefix }) => {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={classes.item}>
      <div className={classes.itemTitleRow}>
        <div className={classes.itemTitle}>{title}</div>

        {rightSideValues.map((valueItem, index) => (
          <React.Fragment key={index}>
            <div className={classes.divider} />
            <div className={classes.itemStack}>
              <span className={classes.itemLabel}>{valueItem.label}</span>
              <span className={classes.itemValue}>{valueItem.value}</span>
            </div>
          </React.Fragment>
        ))}

        <Grid xs={2} container justifyContent="flex-end">
          <ActionButton
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className={classes.deleteButton}
            icon={deleteIcon}
            size="small"
            disabled={disabled}
          />
          <IconButton onClick={toggleExpanded} className={classes.expandIcon} size="small">
            <img
              className={isExpanded ? classes.icon : classes.iconFold}
              src={caret}
              alt={isExpanded ? 'fold' : 'unfold'}
            />
          </IconButton>
        </Grid>
      </div>

      <Collapse in={isExpanded}>
        <div className={classes.itemContent}>
          <Grid container xs={12}>
            {detailFields.map((field, index) => (
              <Field
                key={index}
                xs={field.size || 4}
                type="value"
                id={`${keyPrefix}-${index}-${field.name}`}
                name={`${keyPrefix}-${index}-${field.name}`}
                mode="dark"
                label={field.label}
                value={field.value || 'N/A'}
              />
            ))}
          </Grid>
        </div>
      </Collapse>
    </div>
  );
};

CollapsibleListItem.propTypes = {
  title: PropTypes.string.isRequired,
  rightSideValues: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  detailFields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      size: PropTypes.number
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  keyPrefix: PropTypes.string.isRequired
};

CollapsibleListItem.defaultProps = {
  disabled: false
};

export default CollapsibleListItem;
